var chunkToChildrenMap = {
	"12": [
		686
	],
	"19": [
		886,
		822
	],
	"82": [
		23,
		181
	],
	"221": [
		451
	],
	"506": [
		471
	],
	"663": [
		886
	],
	"814": [
		125
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));